export const GET_EVENT_DROPDOWN_LEVELS_REQUEST =
  'GET_EVENT_DROPDOWN_LEVELS_REQUEST';
export const GET_EVENT_DROPDOWN_LEVELS_REQUEST_SUCCESS =
  'GET_EVENT_DROPDOWN_LEVELS_REQUEST_SUCCESS';
export const GET_EVENT_DROPDOWN_LEVELS_REQUEST_ERROR =
  'GET_EVENT_DROPDOWN_LEVELS_REQUEST_ERROR';
